import { Link } from 'react-router-dom';
import { useCountries } from '../context/CountryContext';

export default function IndiaRelocationCallout() {
  const { countries } = useCountries();
  return (
    <section className="py-20 px-6" style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}>
      <div className="max-w-[1100px] mx-auto text-center text-white">
        <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20 mb-6">
          <span className="text-xl">🇮🇳</span>
          <span className="text-sm uppercase tracking-wider">Now Supporting Graduates from India</span>
        </span>

        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Finished Your Studies in India? Your Next Step Could Be Abroad.
        </h2>

        <p className="text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          IASC Consultancy now offers relocation solutions for graduates from India — whether you're looking for
          a Master's program or a work placement in one of our active destinations. Same guided
          process, same transparent support, now open to you.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {countries.map((country) => (
            <span key={country.country} className="bg-white/10 border border-white/20 px-4 py-2 rounded-full text-sm font-semibold">
              {country.country}
            </span>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/apply"
            className="bg-white text-[#00255a] px-8 py-4 rounded-full font-bold shadow-xl hover:scale-105 transition-all"
          >
            Start Your Application
          </Link>
          <a
            href="https://wa.me/263775827371"
            className="px-8 py-4 rounded-full border-2 border-white/40 hover:border-white transition-all font-semibold"
          >
            Ask a Question on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
